"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productQuoteService = void 0;
const product_quote_service_1 = require("./product-quote-service");
const query_client_1 = require("../query-client");
exports.productQuoteService = new product_quote_service_1.ProductQuoteService({
    resource: 'product-quote',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
